import React from 'react';

export default function Disclaimer() {
  return (
    <section className="disclaimer-section">
      <div className="container">
        <div className="disclaimer-box">
          <i className="bi bi-info-circle-fill" />
          <div>
            <h3>Important information</h3>
            <p>
              Ownezzy provides the website platform only. Individual sellers are responsible for their products, pricing, delivery, returns and customer service.&nbsp;
              <a href="/terms" style={{ color: 'inherit', textDecoration: 'underline' }}>Terms &amp; Conditions →</a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
